import { render, staticRenderFns } from "./DialogCatalogComponent.vue?vue&type=template&id=0c4d8649&scoped=true&"
import script from "./DialogCatalogComponent.vue?vue&type=script&lang=js&"
export * from "./DialogCatalogComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogCatalogComponent.vue?vue&type=style&index=0&id=0c4d8649&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d8649",
  null
  
)

export default component.exports